import './ashtondepotcatering/style';
import FormStructure from './ashtondepotcatering/form_structure';

export default FormStructure;